define('src/queue/delay-queue',[
    'jquery',
    'underscore',
    'utils'
], function($, _, U) {

    /**
     * Queue callbacks with deferred object, called after a delay
     * if a condition is met.
     * @param {int} delay in ms.
     */
    var DelayQueue = function(opt) {
        opt = opt || {};
        this.delay = _.isUndefined(opt.delay) ? 1 : opt.delay;
        this.lastPromise = null;

        if (opt.context) {
            this.context = opt.context;
        }
    };


    DelayQueue.prototype = {
        /**
         * Queue a callback to this async queue.
         * @param  {Function} callback to queue.
         * @param  {Array}   args     arguments to pass to the callback
         * @param  {Object}   opt      trailing, leading, context, delay, condition function
         * @return {jQuery.Deferred}   a promise
         */
        add: function(callback, args, opt) {
            // default options extended with user-defined values
            var options = _.extend({
                trailing: false,
                leading: true,
                context: this.context,
                delay: this.delay
            }, opt);
            var conditionCheck = _.isFunction(options.condition) ? options.condition : false;

            args = _.isArray(args) ? args : [args]; // enforce array for args
            var methodDeferred = $.Deferred();
            var queueDeferred = this._setup();

            // link the next queued function
            queueDeferred.done(function() {

                // call actual method and wrap output in deferred
                // only if condition callback returns true
                if (!conditionCheck || conditionCheck.apply(options.context, args)) {

                    if (options.leading) {
                        callback.apply(options.context, args);
                    }
                    // only defer the resolve
                    setTimeout(function() {
                        if (options.trailing) {
                            callback.apply(options.context, args);
                        }
                        methodDeferred.resolveWith(options.context);
                    }, options.delay);
                } else {
                    methodDeferred.rejectWith(options.context);
                }

            });
            // save it for later.
            this.lastPromise = methodDeferred.promise();
            return this.lastPromise;
        },

        defer: function(callback, args, options) {
            this.add(callback, args, _.extend({
                trailing: true,
                leading: false,
                delay: 1
            }, options));

            return this;
        },

        then: function() {
            this.lastPromise.then.apply(this, arguments);
        },

        /**
         * Handle the queueing of the deferred object.
         * @return {Promise} the promise of the queued function.
         */
        _setup: function() {
            var queueDeferred = $.Deferred();
            var _this = this;
            // when the previous method returns, resolve this one
            $.when(this.lastPromise).always(function() {
                queueDeferred.resolveWith(_this);
            });

            return queueDeferred.promise();
        }
    };

    return DelayQueue;

});

